import React from 'react';
import './ServicesSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * ServicesSection - Sección de servicios reutilizable
 * Muestra una lista de servicios con título, descripción, ícono y precio opcional
 */
const ServicesSection = ({ title, services = [], theme = 'dark', backgroundDecoration }) => {
  return (
    <div className={`servicesContainer servicesContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      {title && <h2 className="servicesTitle">{title.toUpperCase()}</h2>}

      <div className="servicesGrid">
        {services.map((service, index) => (
          <div className="serviceCard" key={index}>
            {service.icon && (
              <div className="serviceIcon">
                {service.icon.startsWith('/') || service.icon.startsWith('./') ? (
                  <img src={service.icon} alt={service.title} className="serviceIconImage" />
                ) : (
                  service.icon
                )}
              </div>
            )}
            <h3 className="serviceTitle">{service.title.toUpperCase()}</h3>
            <p className="serviceDescription">{service.description}</p>
            {service.price && (
              <p className="servicePrice">{service.price}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesSection;
